/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_RoleInputs */

const en_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role *`)
};

const de_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle *`)
};

const fr_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poste *`)
};

const es_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puesto *`)
};

const it_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo *`)
};

const nl_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol *`)
};

const pl_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rola *`)
};

const fi_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävä *`)
};

const da_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle *`)
};

const sv_jobs_search_criteria_label_role = /** @type {(inputs: Jobs_Search_Criteria_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll *`)
};

/**
* | output |
* | --- |
* | "Role *" |
*
* @param {Jobs_Search_Criteria_Label_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_role = /** @type {((inputs?: Jobs_Search_Criteria_Label_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_role(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_role(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_role(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_role(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_role(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_role(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_role(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_role(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_role(inputs)
	return en_jobs_search_criteria_label_role(inputs)
});